import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=1e1b5bf4&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=1e1b5bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b5bf4",
  null
  
)

export default component.exports